export const TASK_TYPE_NAME = {
  MY_TASK: 'MY_TASK',
  DEPARTMENT: 'DEPARTMENT',
  ATTRIBUTE_GROUP: 'ATTRIBUTE_GROUP'
}

export const TASK_CATEGORY_KEY = {
  MY_TASK: 'myTasks',
  DEPARTMENT: 'departments',
  ATTRIBUTE: 'attributes'
}

export const TASK_CATEGORY_VALUE = {
  MY_TASK: 0,
  DEPARTMENT: 1,
  ATTRIBUTE_GROUP: 2
}

export const STATUS = {
  // NOT_STARTED: 'NOT_STARTED',
  // IN_PROGRESS: 'IN_PROGRESS',
  // COMPLETED: 'COMPLETED'
  NOT_STARTED: '未着手',
  IN_PROGRESS: '対応中',
  COMPLETED: '完了'
}

export const STATUS_KEY = {
  0: STATUS.NOT_STARTED,
  1: STATUS.IN_PROGRESS,
  2: STATUS.COMPLETED
}

export const STATUS_VALUE = {
  // NOT_STARTED: 0,
  // IN_PROGRESS: 1,
  // COMPLETED: 2
  未着手: 0,
  対応中: 1,
  完了: 2
}

export const STATUS_CODE = {
  NOT_STARTED: 0,
  IN_PROGRESS: 1,
  COMPLETED: 2
}

export const TASK_STATUS_FILTER_VALUES = {
  UNCOMPLETED: '完了以外',
  COMPLETED: '完了'
}

export const TASK_STATUS_FILTERS = [
  {
    key: 1,
    value: TASK_STATUS_FILTER_VALUES.UNCOMPLETED
  },
  {
    key: 2,
    value: TASK_STATUS_FILTER_VALUES.COMPLETED
  }
]

// PER_PAGE を 100 に設定している理由
// https://soft.backlog.jp/view/SB_NSKGC-1#comment-1501661383
export const DEFAULT_PAGE = {
  PER_PAGE: 100,
  PAGE: 1
}
